import { api, ContactPreferences } from './api';
import { storage } from './storage';

/**
 * Sunucu kesin kaynaktır. Eski sürümde cihazda kalmış true değeri, sunucuda henüz
 * satır yoksa bir kez taşınır. Ağ yoksa yerel ayna yalnız çevrimdışı yedek olur.
 */
export async function loadContactTranslationPreference(
  token: string,
  ownerId: number,
  contactId: number,
  knownRemote?: ContactPreferences | null,
): Promise<boolean> {
  const cached = await storage.getContactTranslation(ownerId, contactId).catch(() => false);
  if (knownRemote === null) return cached;
  try {
    const remote = knownRemote ?? await api.getContactPreferences(token, contactId);
    if (!remote.configured && cached) {
      const migrated = await api.updateContactPreferences(token, contactId, {
        translation_enabled: true,
      });
      await storage.setContactTranslation(ownerId, contactId, migrated.translation_enabled)
        .catch(() => {});
      return migrated.translation_enabled;
    }
    await storage.setContactTranslation(ownerId, contactId, remote.translation_enabled)
      .catch(() => {});
    return remote.translation_enabled;
  } catch {
    return cached;
  }
}

export async function saveContactTranslationPreference(
  token: string,
  ownerId: number,
  contactId: number,
  enabled: boolean
): Promise<boolean> {
  const saved = await api.updateContactPreferences(token, contactId, {
    translation_enabled: enabled,
  });
  await storage.setContactTranslation(ownerId, contactId, saved.translation_enabled)
    .catch(() => {});
  return saved.translation_enabled;
}
